<template>
  <div>
    <v-card class="pa-4 mx-2" flat>
      <v-card-title>
        <b> Dashboard </b>
      </v-card-title>
      <v-card-text class="card-text">
        Visualize todos os relatórios gerados pelos sistema conforme as datas
        que desejar.
      </v-card-text>
    </v-card>

    <v-card class="pa-4 mx-2" flat>
      <v-row class="ma-0" style="cursor: pointer" @click="filters = !filters">
        <v-col class="d-flex align-center" cols="12">
          <h3>{{ filters ? "Esconder" : "Mostrar" }} filtros</h3>
          <v-spacer></v-spacer>
          <v-btn icon large>
            <v-icon>{{
              filters ? "mdi-chevron-up" : "mdi-chevron-down"
            }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-expand-transition>
        <v-row v-if="filters" class="ma-0">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <b> Período e revendas </b>
          </v-col>
          <v-col>
            <v-text-field
              v-model="filter.startDate"
              clearable
              outlined
              label="Data de início"
              type="date"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="filter.endDate"
              clearable
              outlined
              label="Data de término"
              type="date"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="filter.resaleIds"
              clearable
              :items="resales"
              item-text="name"
              item-value="id"
              append-icon="mdi-chevron-down"
              outlined
              label="Revenda"
              menu-props="auto"
              multiple
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <b>Entrega</b>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="filter.state"
              clearable
              append-icon="mdi-chevron-down"
              outlined
              :items="states"
              item-text="sigla"
              item-value="sigla"
              menu-props="auto"
              label="Estado"
              @change="searchCities"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="filter.city"
              clearable
              append-icon="mdi-chevron-down"
              outlined
              menu-props="auto"
              :items="cities"
              label="Cidade"
              item-text="nome"
              item-value="nome"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="filter.country"
              clearable
              append-icon="mdi-chevron-down"
              outlined
              :items="countries"
              menu-props="auto"
              label="País"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-btn outlined @click="reset">Limpar filtros</v-btn>
          </v-col>
        </v-row>
      </v-expand-transition>
    </v-card>

    <v-card elevation="0" class="mx-2" color="transparent" flat>
      <v-row>
        <v-col cols="12">
          <Reimbursement :filter.sync="filter" />
        </v-col>
        <v-col cols="12">
          <minimumStock :filter.sync="filter" />
        </v-col>
        <v-col cols="12">
          <shipments :filter.sync="filter" />
        </v-col>
        <v-col cols="12">
          <skus :filter.sync="filter" />
        </v-col>
        <v-col>
          <products :filter.sync="filter" />
        </v-col>
        <v-col cols="12" sm="7">
          <clients :filter.sync="filter" />
        </v-col>
        <v-col cols="12">
          <resales :filter.sync="filter" />
        </v-col>
        <v-col>
          <discount :filter.sync="filter" />
        </v-col>
        <v-col cols="12" sm="6">
          <searchs :filter.sync="filter" />
        </v-col>
        <v-col>
          <byStatus :filter.sync="filter" />
        </v-col>
        <v-col>
          <cart :filter.sync="filter" />
        </v-col>
        <v-col cols="12">
          <deliveries :filter.sync="filter" />
        </v-col>
        <v-col cols="12" sm="7">
          <canceled :filter.sync="filter" />
        </v-col>
        <v-col>
          <payment-methods :filter.sync="filter" />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import ApiService from "../../../services/ApiService";
import moment from "moment";
import Reimbursement from "./components/reimbursement.vue";
import skus from "./components/skus.vue";
import cart from "./components/cart.vue";
import searchs from "./components/searchs.vue";
import products from "./components/products.vue";
import clients from "./components/clients.vue";
import resales from "./components/resales.vue";
import paymentMethods from "./components/paymentMethods.vue";
import discount from "./components/discount.vue";
import canceled from "./components/canceled.vue";
import byStatus from "./components/byStatus.vue";
import deliveries from "./components/deliveries.vue";
import minimumStock from "./components/minimumStock.vue";
import Shipments from "./components/shipments.vue";

export default {
  components: {
    Shipments,
    skus,
    cart,
    searchs,
    products,
    clients,
    resales,
    paymentMethods,
    discount,
    canceled,
    byStatus,
    deliveries,
    Reimbursement,
    minimumStock,
  },

  data() {
    return {
      filter: {
        startDate: "",
        endDate: "",
        city: "",
        state: "",
        country: "",
        resaleIds: [],
      },
      filters: true,
      apiService: new ApiService(),
      states: [],
      cities: ["Rio de Janeiro", "São Paulo"],
      countries: ["Brasil", "Argentina", "Chile"],
      resales: [],
    };
  },

  created() {
    this.filter.startDate = moment(new Date()).clone().startOf("month").format("YYYY-MM-DD");
    this.filter.endDate = moment(new Date()).clone().endOf("month").format("YYYY-MM-DD");
    this.searchResales();
    this.searchStates();
  },

  methods: {
    reset() {
      this.filter = {
        startDate: "",
        endDate: "",
        city: "",
        state: "",
        country: "",
        resaleIds: [],
      };
    },

    searchResales() {
      this.apiService.get("resale/list").then((response) => {
        this.resales = response;
      });
    },

    searchStates() {
      this.apiService.get("address/states").then((response) => {
        this.states = response.content;
        this.states.sort(function (a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
      });
    },

    searchCities() {
      this.filter.city = "";
      const state = this.states.find((x) => x.sigla == this.filter.state);
      if (state) {
        this.apiService.get(`address/cities/${state.id}`).then((response) => {
          this.cities = response.content;
        });
      }
    },
  },
};
</script>
